// Source code mostly taken from https://github.com/mrdoob/three.js/blob/dev/src/math/Vector3.js

export class Vector2 {
  x: number;
  y: number;

  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
}
